export function buildInviteLink(code: string): string {
	if (typeof window === "undefined") {
		const baseUrl = import.meta.env.VITE_APP_URL ?? "https://tenbagger.xyz";
		return `${baseUrl}/r/${code}`;
	}
	return `${window.location.origin}/r/${code}`;
}
